<template>
    <div class="toggle-menu" v-click-outside="onClickOutside">
        <div class="cursor-pointer" @click="active = !active">
            <i class="far fa-ellipsis-h text-red text-2xl"></i>
        </div>
        <div class="toggle-menu__content text-left" :class="{hidden: !active}">
            <slot></slot>
        </div>
    </div>

</template>

<script>
    import vClickOutside from 'click-outside-vue3'


    export default {
        name: "ToggleMenu",
        data() {
            return {
                active: false,
            }
        },
        directives: {
            clickOutside: vClickOutside.directive
        },
        methods: {
            onClickOutside () {
                this.active = false;
            }
        }
    }
</script>

<style scoped>

</style>
